import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { Box } from '@mui/material';

// ==============================|| RED EQUALIZER SPINNER ||============================== //
const eqAnimation = keyframes`
  0%, 100% { transform: scaleY(0.6); }
  50% { transform: scaleY(1.4); }
`;

const EqualizerWrapper = styled('div')(({ size, color }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: size ? size / 8 : '3px',
  height: size || 24,
  margin: 'auto',
  '& > div': {
    width: size ? size / 6 : '4px',
    backgroundColor: color === 'inherit' ? 'currentColor' : '#D50F2B',
    borderRadius: '2px',
    animation: `${eqAnimation} 1.2s ease-in-out infinite`,
  },
  '& > div:nth-of-type(1)': { height: '50%', animationDelay: '0s' },
  '& > div:nth-of-type(2)': { height: '70%', animationDelay: '0.15s' },
  '& > div:nth-of-type(3)': { height: '100%', animationDelay: '0.3s' },
  '& > div:nth-of-type(4)': { height: '70%', animationDelay: '0.45s' },
  '& > div:nth-of-type(5)': { height: '50%', animationDelay: '0.6s' },
}));

export const ModernSpinner = ({ size = 24, color = 'primary', style }) => {
  return (
    <EqualizerWrapper size={size} color={color} style={style}>
      <div />
      <div />
      <div />
      <div />
      <div />
    </EqualizerWrapper>
  );
};


// ==============================|| RED TOP BAR ||============================== //
const slide = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
`;

const TopBarWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2001,
  width: '100%',
  height: '4px',
  background: 'rgba(213, 15, 43, 0.1)', 
  overflow: 'hidden',
  backdropFilter: 'blur(4px)',
}));

const GlowLine = styled('div')(({ theme }) => ({
  width: '50%',
  height: '100%',
  background: 'linear-gradient(90deg, transparent, #D50F2B, #E8002B, transparent)',
  animation: `${slide} 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite`,
  boxShadow: '0 0 12px #D50F2B, 0 0 6px #E8002B',
  borderRadius: '4px',
}));

export const ModernTopBar = () => (
  <TopBarWrapper>
    <GlowLine />
  </TopBarWrapper>
);
